<template>
  <v-container fluid class="pa-0">
    <AssignStudentTaskButton v-if="isTeacher" />
    <SaveProgressButton v-if="isTeacher" />
    <app-navigation
      :value="$vuetify.breakpoint.lgAndUp || $store.getters['modules/showDrawer']"
    ></app-navigation>
    <div class="pb-4">
      <router-view></router-view>
    </div>
    <app-copyright absolute />
  </v-container>
</template>
<script>
import Navigation from "./Navigation";
import Copyright from "@/components/Copyright.vue";
import SaveProgressButton from "./SaveProgressButton.vue";
import AssignStudentTaskButton from "./AssignStudentTaskButton.vue";
import studentMixin from "../../mixins/studentMixin";

export default {
  components: {
    appNavigation: Navigation,
    appCopyright: Copyright,
    SaveProgressButton,
    AssignStudentTaskButton,
  },
  mixins: [studentMixin],
  methods: {
    onKeyDown() {
      return "Confirm You want to refresh the page?";
    },
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
};
</script>
